<template>
    <fragment>
        <special-account-info-panel
            :data-source="cashPaymentRecord"
            @on-refresh="() => getCashPaymentInfo(orderNo)"
        />

        <deposit-info-panel
            :initial-values="cashPaymentRecord"
            @on-ok="() => $emit('on-ok')"
        />
    </fragment>
</template>
<script>
import Fragment from '@components/Fragment'
import DepositInfoPanel from './DepositInfoPanel'
import SpecialAccountInfoPanel from '../../SpecialAccountInfoPanel'

export { PORTAL_KEY } from './DepositInfoPanel'

export default {
    name: 'ModalContent',
    components: {
        Fragment,
        DepositInfoPanel,
        SpecialAccountInfoPanel
    },
    props: {
        // 现金缴纳信息
        cashPaymentRecord: {
            type: Object,
            default: () => ({})
        }
    }
}
</script>
